export default "__VITE_ASSET__A$_prGOb__"